export { default } from './Typography';